import { render } from "./RefundPolicy.vue?vue&type=template&id=108fcfd4"
import script from "./RefundPolicy.vue?vue&type=script&lang=js"
export * from "./RefundPolicy.vue?vue&type=script&lang=js"

import "./RefundPolicy.vue?vue&type=style&index=0&id=108fcfd4&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__